"use client";
import {
  useMenuStore
} from "../__chunks/MAMNGFY7.js";
import {
  MenuContextProvider
} from "../__chunks/IG6NVGLB.js";
import "../__chunks/VBF5EZBB.js";
import "../__chunks/UNDSQXBK.js";
import "../__chunks/7GBW5FLS.js";
import "../__chunks/Y6GYTNQ2.js";
import "../__chunks/3D6OCOHF.js";
import "../__chunks/MADQZZRL.js";
import "../__chunks/TWDHCE7Y.js";
import "../__chunks/TE637IA7.js";
import "../__chunks/XXVAHUAO.js";
import "../__chunks/J55AVALY.js";
import "../__chunks/5M6RSQEC.js";
import "../__chunks/E5E7G32I.js";
import "../__chunks/XWCFCD3Q.js";
import "../__chunks/I62TROYO.js";
import "../__chunks/HZJ2XALY.js";
import "../__chunks/EKQEJRUF.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import "../__chunks/4R3V3JGP.js";

// src/menu/menu-provider.tsx
import { jsx } from "react/jsx-runtime";
function MenuProvider(props = {}) {
  const store = useMenuStore(props);
  return /* @__PURE__ */ jsx(MenuContextProvider, { value: store, children: props.children });
}
export {
  MenuProvider
};
